import React from "react";

import Config from "@app/config";

const DashboardDemoVideo = () => {
  return (
    <div>
      <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
        <iframe
          src={Config.demoVideo}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
          title="Read Dashboard Demo Video"
        ></iframe>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>
    </div>
  );
};

export default DashboardDemoVideo;
